import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormsModule  } from '@angular/forms';
import { FileUploadControl, FileUploadModule, FileUploadValidators } from '@iplab/ngx-file-upload';
import { HotToastService } from '@ngxpert/hot-toast';

import { FileUploaderService } from '@shared/services/file-uploader.service';

const GB_IN_BYTES = 1073741824;
const MB_IN_BYTES = 1048576;
const KB_IN_BYTES = 1024;

@Component({
  selector: 'sas-file-uploader',
  standalone: true,
  imports: [FormsModule, FileUploadModule, CommonModule],
  templateUrl: './sas-file-uploader.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrl: './sas-file-uploader.component.scss'
})
export class SasFileUploaderComponent {
  fileUploaderService = inject(FileUploaderService);
  notification = inject(HotToastService);

  @Input({ required: true }) uploadWsUrl!: string;
  @Input() mimeTypes?: string;
  @Input() maxFileSize?: any;
  @Input() uploadMultiple?: boolean;
  @Input() uploadValidate?: Function;
  @Input() uploadData: any = {};
  @Output() onUpload = new EventEmitter<any>();
  @Output() onUploadError = new EventEmitter<any>();

  fileUploadControl = new FileUploadControl({ listVisible: false });
  maxFileSizeBytes: number = 100000000; //arround 100MB as maximum by default
  isMultiple: boolean = true;
  listFiles: Array<any> = [];
  invalidFiles: Array<any> = [];

  ngOnChanges(changes: any) {
    if (changes.maxFileSize) {
      this.maxFileSizeBytes = this.maxFileSize ?? 100000000;

      this.fileUploadControl.setValidators(FileUploadValidators.fileSize(this.maxFileSizeBytes))
    }
  }

  ngOnInit() {
    this.maxFileSizeBytes = this.maxFileSize ?? 100000000;
    if (this.mimeTypes === undefined || this.mimeTypes === null || this.mimeTypes === '') {
      this.mimeTypes = 'image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    }

    this.isMultiple = this.uploadMultiple ?? true
  }

  ngDoCheck() {
    if (this.invalidFiles.length > 0) {
      for (let i = 0; i < this.invalidFiles.length; i++) {
        const message = `The file ${this.invalidFiles[i].name} exceed the max file size of ${this.sizeDisplayName(this.invalidFiles[i].$errorParam)}`;

        this.notification.error(message);
        this.invalidFiles.splice(i, 1);
      }
    }
  }

  private sizeDisplayName(bytesSize: number) {
    let result = 0;
    let text = '';

    if (bytesSize >= GB_IN_BYTES) {
      result = bytesSize / GB_IN_BYTES;
      text = 'GB';
    } else if (bytesSize >= MB_IN_BYTES) {
      result = bytesSize / MB_IN_BYTES;
      text = 'MB';
    } else {
      result = bytesSize / KB_IN_BYTES;
      text = 'KB';
    }

    return result.toFixed(2) + text;
  }

  addFiles() {
    // console.log(this.fileUploadControl.getError());
    // console.log(this.fileUploadControl.discardInvalid());

    if (this.listFiles.length !== 0) {
      const validateFile = this.uploadValidate;

      this.listFiles.forEach(file => {
        const data = this.uploadData || {};
        data.file = file;

        this.fileUploaderService.uploadFile(this.uploadWsUrl, data)
          .subscribe({
            next: (res) => {
              if (validateFile !== undefined) {
                if (validateFile({ data: res, config: { data } })) {
                  this.onUpload.emit({ data: res, config: { data } })
                } else {
                  this.onUploadError.emit({ data: res, config: { data } })
                }
              } else {
                this.onUpload.emit({ data: res, config: { data } })
              }
            },
            error: (err) => {
              console.log('Error status: ', err.statusText);
              this.onUploadError.emit({ data: err, config: { data } })
            }
          });
      });

      this.listFiles = [];
    }
  }
}
